var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('b-form-select',{staticStyle:{"border":"1px solid gray","width":"100%"},style:({color: _vm.$store.state.siteData.legColors[_vm.index], borderTop: '1px solid gray'}),attrs:{"size":"sm","options":_vm.options},model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }